import { useEffect, useState } from 'react';
import { PasswordPoliciesList } from '../../../../main/constants';
import { PasswordPolicie } from '../../../../domain/shared/PasswordPoliciesEntity';

export const PasswordPoliciesController = () => {
    const [passwordPolicies, setPasswordPolicies] = useState<PasswordPolicie[]>([]);

    useEffect(() => {
        setPasswordPolicies(PasswordPoliciesList);
    }, []);

    return { passwordPolicies };
};
